import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const UsersApi = createApi({
	reducerPath: "Users",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_API_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),
	endpoints: (builder) => ({
		getAllUsers: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10000;
				const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
				const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
				const search = val.search ? `&search=${val.search}` : "";
				return `/users?page=${page}&pageSize=${limit}${search}${sortBy}${sortOrder}`;
			},
		}),
		getChildUsers: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10000;
				const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
				const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
				const search = val.search ? `&search=${val.search}` : "";
				return `/users?userId=${val.userId}&page=${page}&pageSize=${limit}${search}${sortBy}${sortOrder}`;
			},
		}),
		getSpecificUser: builder.query({
			query: (userId) => `/users/${userId}`,
		}),
		addUser: builder.mutation({
			query: (val) => ({
				url: `/users`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		editUser: builder.mutation({
			query: ({ id, val }) => ({
				url: `/users/${id}`,
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteUser: builder.mutation({
			query: (id) => ({
				url: `/users/${id}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const {
	useGetAllUsersQuery,
	useGetChildUsersQuery,
	useGetSpecificUserQuery,
	useLazyGetChildUsersQuery,
	useLazyGetAllUsersQuery,
	useLazyGetSpecificUserQuery,
	useAddUserMutation,
	useEditUserMutation,
	useDeleteUserMutation,
} = UsersApi;
